/*
 * Barra de filtros común a todas las secciones: Hoy · Semana · Mes · Personalizado, flechas para ir al
 * periodo anterior o siguiente (no deja pasar de hoy) y selectores de zona, tienda y empleado.
 * No guarda estado propio: recibe los filtros (leídos de la URL) y entrega los nuevos con onChange.
 * Las opciones de zona/tienda/empleado salen de las jornadas del periodo (utils/rows.js filterOptions);
 * si la URL trae un filtro sin datos en el periodo, se muestra igual para poder quitarlo.
 */
import React from "react";
import {canGoForward, changePeriod, periodLabel, shiftPeriod} from "../utils/period";

const PERIOD_BUTTONS = [
    {key: 'hoy', label: 'Hoy'},
    {key: 'semana', label: 'Semana'},
    {key: 'mes', label: 'Mes'},
    {key: 'personalizado', label: 'Personalizado'},
];

function withSelected(options, value) {
    if (!value || options.some((option) => option.id === value)) return options;
    return [...options, {id: value, nombre: 'Sin marcaciones en el periodo'}];
}

const EntitySelect = ({label, allLabel, value, options, onChange}) => (
    <label className="mc-select">
        <span className="mc-select__label">{label}</span>
        <select className="form-control" value={value} onChange={(event) => onChange(event.target.value)}>
            <option value="">{allLabel}</option>
            {withSelected(options, value).map((option) => (
                <option key={option.id} value={option.id}>{option.nombre}</option>
            ))}
        </select>
    </label>
);

const PeriodFilters = ({filters, today, options, rangeMessage, onChange}) => {
    const update = (changes) => onChange({...filters, ...changes});
    const hasEntityFilter = Boolean(filters.zona || filters.tienda || filters.empleado);
    return (
        <div className="mc-filters">
            <div className="mc-periods" role="group" aria-label="Periodo">
                {PERIOD_BUTTONS.map((item) => (
                    <button key={item.key} type="button" aria-pressed={filters.periodo === item.key}
                            className={`mc-periods__item${filters.periodo === item.key ? ' is-active' : ''}`}
                            onClick={() => onChange(changePeriod(filters, item.key, today))}>
                        {item.label}
                    </button>
                ))}
            </div>
            <div className="mc-stepper">
                <button type="button" className="mc-icon-button" aria-label="Periodo anterior"
                        disabled={Boolean(rangeMessage)} onClick={() => onChange(shiftPeriod(filters, -1))}>
                    <i className="bx bx-chevron-left" aria-hidden="true"/>
                </button>
                {filters.periodo === 'personalizado' ? (
                    <div className="mc-stepper__dates">
                        <label className="mc-select">
                            <span className="mc-select__label">Desde</span>
                            <input type="date" className="form-control" value={filters.desde} max={today}
                                   onChange={(event) => update({desde: event.target.value})}/>
                        </label>
                        <label className="mc-select">
                            <span className="mc-select__label">Hasta</span>
                            <input type="date" className="form-control" value={filters.hasta} max={today}
                                   onChange={(event) => update({hasta: event.target.value})}/>
                        </label>
                    </div>
                ) : (
                    <p className="mc-stepper__label" aria-live="polite">{periodLabel(filters, today)}</p>
                )}
                <button type="button" className="mc-icon-button" aria-label="Periodo siguiente"
                        disabled={Boolean(rangeMessage) || !canGoForward(filters, today)} onClick={() => onChange(shiftPeriod(filters, 1))}>
                    <i className="bx bx-chevron-right" aria-hidden="true"/>
                </button>
            </div>
            {rangeMessage && <p className="mc-field-error" role="alert">{rangeMessage}</p>}
            <div className="mc-selects">
                <EntitySelect label="Zona" allLabel="Todas las zonas" value={filters.zona} options={options.zonas}
                              onChange={(zona) => update({zona, tienda: '', empleado: ''})}/>
                <EntitySelect label="Tienda" allLabel="Todas las tiendas" value={filters.tienda} options={options.tiendas}
                              onChange={(tienda) => update({tienda, empleado: ''})}/>
                <EntitySelect label="Empleado" allLabel="Todas las personas" value={filters.empleado}
                              options={options.empleados} onChange={(empleado) => update({empleado})}/>
            </div>
            {hasEntityFilter &&
                <button type="button" className="btn btn-link btn-sm mc-clear"
                        onClick={() => update({zona: '', tienda: '', empleado: ''})}>
                    Quitar filtros
                </button>}
        </div>
    );
};

export default PeriodFilters;
